import { Button, Box } from '@mui/material';
import Preloader from 'components/Preloader';
import { useTranslation } from 'react-i18next';
import EmptyMenu from 'components/MenuNew/EmptyMenu';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import { usePosSections } from 'pages/PosSettings/hooks/usePosSections';
import CreateOrEditForm from 'pages/PosSettings/Sections/CreateOrEditForm';
import ConfirmPromptModal from 'components/ConfirmPromptModal/ConfirmPromptModal';

// NOTE: The following components are imported from 'TableOrdering',
import { MODE, MUI_TO_SX_STYLES } from 'pages/TableOrdering/config';
import TableOrderModal from 'pages/TableOrdering/Tables/TableOrderModal';
import { HeaderContainer, StripedDataGrid } from 'pages/TableOrdering/styles';

const Sections = () => {
  const { t } = useTranslation();
  const {
    handleSubmit,
    handleCancel,
    formMethods,
    sectionColumns,
    sectionFilter,
    loading,
    open,
    setOpen,
    mode,
    rowsPerPage,
    setRowsPerPage,
    lastCreatedSection,
  } = usePosSections();

  return (
    <Box>
      <HeaderContainer>
        <ConfirmPromptModal
          handleConfirm={formMethods.handleSubmit(handleSubmit)}
          submitData={formMethods.getValues()}
          hasUnsavedChanges={formMethods.formState.isDirty}
          formState={formMethods}
        />
        <TableOrderModal
          open={open}
          handleClose={handleCancel}
          title={
            mode === MODE.CREATE ? 
            t('table_ordering.add_section') : 
            t('table_ordering.edit_section')
          }
          disabled={
            !formMethods.formState.isDirty || 
            !formMethods.formState.isValid
          }
          saveTitle={
            mode === MODE.CREATE ? 
            t('table_ordering.add_section') : 
            t('table_ordering.save')
          }
          cancelTitle={'Cancel'}
          formMethods={formMethods}
          handleSubmit={handleSubmit}
          loading={loading}
        >
          <CreateOrEditForm />
        </TableOrderModal>
        <Button
          id="sectionsAdd"
          onClick={() => setOpen(true)}
          variant="contained"
          color="primary"
          type="button"
          disabled={open}
          className={`${open ? 'disabledButton' : ''}`}
          startIcon={<AddOutlinedIcon />}
        >
          {t('table_ordering.add_section')}
        </Button>
      </HeaderContainer>
      <StripedDataGrid
        sx={MUI_TO_SX_STYLES}
        autoHeight={true}
        hideFooterSelectedRowCount={true}
        getRowClassName={(params) => (
          params?.row?.sectionDetails?.uuid === lastCreatedSection ?
           'highlight_last-selected_item' : ''
        )}
        isEditable={false}
        rows={sectionFilter}
        rowsPerPageOptions={[100]}
        hideFooter={true}
        columns={sectionColumns}
        pageSize={rowsPerPage}
        onPageSizeChange={(newPageSize) => setRowsPerPage(newPageSize)}
        components={{
          LoadingOverlay: Preloader,
          NoRowsOverlay: () => (
            <Box sx={{ mt: '100px' }}>
              <EmptyMenu text={t('There are no sections yet')} />
            </Box>
          )
        }}
        loading={loading}
      />
    </Box>
  );
};

export default Sections;
